import React, { useRef, useCallback, useState } from 'react';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage, useIntl } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownOverlay } from 'ui-components/components/INTERNAL/dropdown/dropdown-overlay';
import { noop } from 'ui-components/default-props/noop';

import styles from './styles.module.less';
import messages from '../../messages';
import DownloadSample from '../download-sample';

const DOWNLOAD = 'DOWNLOAD';

const renderOverlay = (stores, onClick, template, isHovered, ref, setHoveredItem, overlayRef) => {
  return (
    <DropdownOverlay
      ref={overlayRef}
      closeWhenChildrenClicked
      dropdownMenuShouldHaveWidthOfButton={false}
      isNested
      isOpen={isHovered}
      menuPosition='bottom-right'
      onClose={() => setHoveredItem(undefined)}
      onKeyDown={noop}
      targetRef={ref}
    >
      <div className={styles['overlay-wrapper']}>
        {stores.map(({ storeGuid, name }) => {
          return (
            <DropdownMenuItem key={storeGuid} className={styles['nested-item']} onClick={() => onClick(storeGuid, template)}>
              {name}
            </DropdownMenuItem>
          );
        })}
      </div>
    </DropdownOverlay>
  );
};

/**
 * @param {object} props
 * @param {(template: import('../../types').PackingSlipTemplate) => void} props.onCopyTemplate
 * @param {(template: import('../../types').PackingSlipTemplate) => void} props.onDeleteTemplate
 * @param {(template: import('../../types').PackingSlipTemplate) => void} props.onEditTemplate
 * @param {import('../../types').PackingSlipTemplate} props.template
 * @returns {React.JSX.Element}
 */
export const ActionMenu = ({ onCopyTemplate, onDeleteTemplate, onEditTemplate, template }) => {
  const intl = useIntl();
  const [hoveredItem, setHoveredItem] = useState();
  const onDropdownClose = useCallback(() => {
    setHoveredItem(undefined);
  }, []);
  const ref = useRef();
  const overlayRef = useRef();
  const isHtmlTemplate = !!template.htmlTemplateKey;

  return (
    <DropdownMenu dropdownMenuClassName={styles['dropdown-display']} onClose={onDropdownClose}>
      <DropdownMenuToggler
        ariaLabel={intl.formatMessage(messages.templateActionsMenu)}
        className={styles['actions-dropdown']}
        hideChevron
        openClassName={styles['icon-open']}
        theme='unstyled'
      >
        <div className={styles['icon-wrapper']}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </DropdownMenuToggler>
      <DropdownMenuItem disabled={template.shared} onClick={() => onEditTemplate(template)} onMouseEnter={() => setHoveredItem(undefined)}>
        <FormattedMessage {...messages.editAction} />
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onCopyTemplate(template)} onMouseEnter={() => setHoveredItem(undefined)}>
        <FormattedMessage {...messages.copyAction} />
      </DropdownMenuItem>
      {!isHtmlTemplate ? (
        <DropdownMenuItem className={styles.nested} onMouseEnter={() => setHoveredItem(DOWNLOAD)}>
          <DownloadSample>
            {({ stores, onDownloadClick }) => (
              <>
                <div ref={ref} className={styles['nested-anchor']}>
                  <FormattedMessage {...messages.downloadAction} />
                  <FontAwesomeIcon icon={faCaretRight} />
                </div>
                {hoveredItem === DOWNLOAD &&
                  renderOverlay(stores, onDownloadClick, template, hoveredItem === DOWNLOAD, ref, setHoveredItem, overlayRef)}
              </>
            )}
          </DownloadSample>
        </DropdownMenuItem>
      ) : null}
      <DropdownMenuItem
        className={styles.danger}
        disabled={template.shared}
        onClick={() => onDeleteTemplate(template)}
        onMouseEnter={() => setHoveredItem(undefined)}
      >
        <FormattedMessage {...messages.deleteAction} />
      </DropdownMenuItem>
    </DropdownMenu>
  );
};
